import { render, staticRenderFns } from "./MyComputerInstaller.vue?vue&type=template&id=4942b1d8&scoped=true&"
import script from "./MyComputerInstaller.vue?vue&type=script&lang=js&"
export * from "./MyComputerInstaller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4942b1d8",
  null
  
)

export default component.exports